<template>
  <footer class="footer">
    <div class="f-content">
      <div class="f-left">
        <div class="tel">
          <img src="../../../assets/tel-w.png" alt="乐接活" />
          <span>0512-67903209</span>
        </div>
        <div class="address">
          <img src="../../../assets/dingwei.png" alt="乐接活" />
          <span>苏州市吴中区甪直镇东方大道100号1幢</span>
        </div>
        <div class="info">
          <span @click="skipTo('1')">关于霖珑云科</span>
          <span class="circle"></span>
          <span @click="skipTo('2')">关于乐接活</span>
          <span class="circle"></span>
          <span @click="skipTo('3')">企业登录</span>
        </div>
      </div>
      <div class="f-right">
        <div class="qrcode">
          <div class="code">
            <!-- <img src="../../../assets/code.png" />
            <span>下载试用</span> -->
          </div>
          <div class="code">
            <img src="../../../assets/wechat1.png" alt="乐接活" />
            <span>下载试用</span>
          </div>
        </div>
      </div>
    </div>
    <div class="f-btm">
      <span>Copyright © linlongyun.com版权所有 | <a data-v-7c607466="" href="//beian.miit.gov.cn" target="_blank">苏ICP备19029986 号-1</a> ©2022 霖珑云科</span>
      <span class="line"></span>
      <img src="../../../assets/icp.png" alt="乐接活" />
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footers",
  computed: {},
  methods: {
    skipTo(type){
      let url = 'https://qiye.lejiehuo.com/main/login';
      if(type == 1){
        url = 'https://www.linlongyun.com';
      }else if(type == 2){
        url = 'https://lejiehuo.linlongyun.com/about';
      }
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin: 0 auto;
  background: $white;
  // padding: 34px 0 0;
  .f-content{
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    display: flex;
    padding: 36px 100px;
    >div{
      flex: 1;
    }
    .f-left{
      text-align: left;
      display: inline-block;
      .tel{
        img{
          width: 36px;
          height: 36px;
          vertical-align: middle;
        }
        span{
          font-size: 28px;
          font-weight: 100;
          color: #666;
          margin-left: 10px;
          vertical-align: middle;
        }
      }
      .address{
        width: auto;
        margin-top: 16px;
        img{
          width: 10px;
          height: 12px;
          vertical-align: middle;
        }
        span{
          font-size: 12px;
          color: #666;
          font-weight: 400;
          vertical-align: middle;
          margin-left: 4px;
        }
      }
      .info{
        margin-top: 14px;
        cursor: pointer;
        .circle{
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background:rgba(102,102,102,.6);
          margin: 0 8px;
          vertical-align: middle;
          &:hover{
            background: #206EFD;
          }
        }
        span{
          vertical-align: middle;
          font-size: 12px;
          color: #666;
          &:hover{
            color: #206EFD;
          }
        }
      }
    }
    .f-right{
      .qrcode{
        overflow: hidden;
        .code{
          float: right;
          text-align: center;
          margin-left: 70px;
          img{
            width: 72px;
            display: block;
            margin-bottom: 10px;
          }
          span{
            font-size: 12px;
            color: #666;
          }
        }
      }
    }
    
  }
  .f-btm{
    width: 100%;
    height: 56px;
    background: #F5F5F5;
    text-align: center;
    line-height: 56px;
    span{
      vertical-align: middle;
      font-size: 12px;
      color: #666;
      font-weight: 400;
    }
    .line{
      display: inline-block;
      width: 2px;
      height: 16px;
      background:rgba(153,153,153,.2);
      margin: 0 18px;
    }
    img{
      width: 48px;
      height: 18px;
      vertical-align: middle;
    }
  }
}
</style>